import { useAuthStore } from "../auth/authStore";
import { createGenerationNotificationsClient } from "./generation-notifications-client";
import { httpClient } from "./httpClient";

const client = createGenerationNotificationsClient(useAuthStore, httpClient);
export const getGenerationNotificationDiagnostics = client.list;
export const recoverGenerationNotificationForOwner = client.recover;
export const reconcileLegacyGenerationNotificationForOwner = client.reconcileLegacy;
